import { useMemo } from 'react';
import {
  DEFAULT_SCAFFOLDER_FIELD_EXTENSIONS,
  FieldExtensionOptions,
} from '../../extensions';

/**
 * Returns the default rjsf fields registry providing all the customized Pickers we have in witboost
 * @param additionalFields allows to provide additional fields, they will override the default Pickers with the same name
 * @returns
 */
export const useDefaultFields = (
  additionalFields?: FieldExtensionOptions<any, any>[],
) => {
  return useMemo(() => {
    const additional = additionalFields ?? [];
    return {
      ...Object.fromEntries(
        // additional fields with the same name as the default ones will the latter
        DEFAULT_SCAFFOLDER_FIELD_EXTENSIONS.concat(additional).map(
          ({ name, component }) => [name, component],
        ),
      ),
    };
    // TODO type properly so it returns a type compatible with rjsf "fields" prop
  }, [additionalFields]) as any;
};
